
import React from 'react';
import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';

export default function FinalCTASection() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-50px' });

  const scrollToOffer = () => {
    const element = document.getElementById('offer');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section ref={ref} className="relative min-h-[100dvh] w-full overflow-hidden bg-black">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/b66a7d3fce0ec8099d6508e6c0faefc9/218219c4ba2d7bd2fdaa59ea73ac98f3.png"
          alt="Premium Pistol Lighter"
          className="w-full h-full object-cover opacity-30"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-black/30" />
      </div>

      {/* Content */}
      <div className="relative z-10 min-h-[100dvh] flex items-center justify-center pb-32 sm:pb-36 md:pb-40 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8 }}
            className="font-serif text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-7xl text-white mb-3 sm:mb-4 md:mb-6 leading-tight"
          >
            Carry clean.
            <br />
            Carry premium.
          </motion.h2>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="text-white/80 text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl mb-6 sm:mb-8 md:mb-12 max-w-2xl mx-auto"
          >
            Refillable flame. Protected cigarettes. One sleek device.
          </motion.p>

          <motion.button
            initial={{ opacity: 0, y: 20 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.4 }}
            whileTap={{ scale: 0.95 }}
            onClick={scrollToOffer}
            className="bg-white text-black px-6 sm:px-8 md:px-10 lg:px-12 py-3 sm:py-4 md:py-5 rounded-full text-sm sm:text-base md:text-lg font-medium hover:bg-white/90 transition-all whitespace-nowrap cursor-pointer active:scale-95"
          >
            Get Yours Now
          </motion.button>
        </div>
      </div>

      {/* Footer */}
      <motion.footer
        initial={{ opacity: 0 }}
        animate={isInView ? { opacity: 1 } : {}}
        transition={{ duration: 0.8, delay: 0.6 }}
        className="absolute bottom-0 left-0 right-0 py-4 sm:py-6 md:py-8 px-4 border-t border-white/10"
      >
        <div className="max-w-7xl mx-auto flex flex-col items-center gap-3 sm:gap-4 text-white/60 text-[9px] sm:text-[10px] md:text-xs lg:text-sm">
          <div className="flex items-center gap-3 sm:gap-4 md:gap-6 flex-wrap justify-center">
            <a href="#" className="hover:text-white transition-colors py-1">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors py-1">
              Terms of Service
            </a>
            <a href="#" className="hover:text-white transition-colors py-1">
              Contact
            </a>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white transition-colors py-1"
            >
              Powered by Readdy
            </a>
          </div>
          <p className="text-center">© 2024 Pistol Lighter. All rights reserved.</p>
        </div>
      </motion.footer>
    </section>
  );
}
